<script setup>
import { onMounted, onBeforeUnmount, ref, nextTick } from 'vue';

const iframeRef = ref(null);

// viewport-fit=cover is set, so window.innerHeight includes safe areas.
// We read env(safe-area-inset-bottom) via a temporary element to subtract the
// system bar height (home indicator on iOS, nav bar on Android).
const getSafeAreaInsets = () => {
	const el = document.createElement('div');
	el.style.cssText = 'position:fixed;inset:0;pointer-events:none;visibility:hidden;' +
		'padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px)';
	document.body.appendChild(el);
	const style = getComputedStyle(el);
	const top = parseInt(style.paddingTop) || 0;
	const bottom = parseInt(style.paddingBottom) || 0;
	el.remove();
	return { top, bottom };
};

const applyHeight = () => {
	if (iframeRef.value) {
		const { top, bottom } = getSafeAreaInsets();
		iframeRef.value.style.height = `${window.innerHeight - top - bottom}px`;
	}
};

// Debounced to avoid capturing mid-animation heights (e.g. orientation change)
let resizeTimer;
const resizeIframe = () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(applyHeight, 150);
};

const loadApp = (url, token, form) => {
	form.action = url;
	form.token.value = token;
	form.submit();
};

onMounted(() => {
	window.addEventListener('resize', resizeIframe);

	window.addEventListener('message', (event) => {
		if (event.data?.type === 'loadApp') {
			const { url, token } = event.data;

			const form = document.createElement('form');
			form.method = 'POST';
			form.action = url;
			form.style.display = 'none';

			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = 'token';
			input.value = token;

			form.appendChild(input);
			document.body.appendChild(form);
			form.submit();
		}
	});

	nextTick(applyHeight);
});

onBeforeUnmount(() => {
	window.removeEventListener('resize', resizeIframe);
	clearTimeout(resizeTimer);
});
</script>

<template>
	<div class="layout">
		<iframe ref="iframeRef" src="/m.eagle/default.htm" width="100%" style="border: none" allow="geolocation *; fullscreen *; clipboard-write; display-capture"></iframe>
	</div>
</template>

<style scoped>
iframe {
	border: none;
	transform: scale(1);
	transform-origin: top left;
}

.layout {
	height: 100dvh;
	overflow: hidden;
}
</style>
